import { extendTheme } from '@chakra-ui/react';

import HalfTypographySize from './TypographySize';

const breakpoints = {
  sm: '30em',
  md: '48em',
  '2md': '50em',
  lg: '62em',
  xl: '80em',
  '2xl': '96em',
  '3xl': '100em',
};

const engeneTheme = extendTheme({
  breakpoints,
  fontSizes: { mobile: HalfTypographySize },
});

export default engeneTheme;
